import { EducationCard } from "./EducationCard";

export const Education = ({ data }) => {
  return (
    <div id="team" className="text-center">
      <span className="teamAnchor" id="teamAnchor" aria-hidden="true"></span>
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Education</h2>
          <p>
            Abu Hurairah reported the Prophet (ﷺ) as saying:<br />
            If anyone pursues a path in search of knowledge, Allah will thereby make easy for him a path to paradise;<br />
            Sunan Abi Dawud
          </p>
        </div>
        <div id="row">
          {data
            ? data.map((item, index) => (
                <EducationCard
                  key={`${item.name}-${index}`}
                  name={item.name}
                  img={item.img}
                  link={item.link}
                />
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
